<template>
  <div class="animated fadeIn">
    <b-card-body id="areaImprimir">
      <b-row class="mb-2">
        <b-col>
          <b-img :src="img" left fluid style="max-height: 100px" alt="Responsive image" class="rounded pb-0"></b-img>
          <h1 class="text-right">GUÍA DE DESPACHO #{{ waybill.number }}</h1>
          <p class="text-right">{{ waybill.waybill_date | moment }}</p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-table-simple fixed>
          <b-tbody>
            <b-tr>
              <b-td>
                <b>{{ waybill.client_customer.company_name }}</b> <br />
                <b>Emisor:</b> <br />
                {{ waybill.company.company_name }}<br />
                {{ waybill.company.company_number }}<br />
                {{ waybill.company.address1 }}<br />
                {{ waybill.company.address2 }}<br />
              </b-td>
              <b-td class="text-right">
                <b> </b> <br />
                <b>Recibidor</b> <br />
                {{ waybill.recipient_company.company_name }}<br />
                {{ waybill.recipient_company.company_number }}<br />
                {{ waybill.recipient_company.address1 }}<br />
                {{ waybill.recipient_company.address2 }}<br />
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-table-simple fixed>
          <b-tbody>
            <b-tr>
              <b-td>
                <b> <u> Detalles</u></b> <br />
                Nombre Chofer: {{ waybill.truck_driver }}<br />
                Rut Chofer: {{ waybill.custom_fields.rut_chofer }}<br />
                Patente: {{ waybill.license_plate }}<br />
              </b-td>
              <b-td>
                <b> <u> </u></b> <br />
                Sucursal: {{ waybill.custom_fields.sucursal }}<br />
                Traslado: {{ waybill.custom_fields.traslado }}<br />
                Despacho: {{ waybill.custom_fields.despacho }}<br />
              </b-td>
              <b-td>
                <b> <u>Notas</u></b> <br />
                <span style="white-space: pre">{{ waybill.note }}</span>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-row>
      <h6 class="mb-3 font-weight-bold">Detalle de guía de despacho:</h6>
      <div class="table-responsive-sm">
        <table class="table table-sm">
          <thead>
            <tr class="font-weight-bold text-uppercase">
              <th class="align-middle">Cod.</th>
              <th class="align-middle">Fam.</th>
              <th class="align-middle">Material</th>
              <th class="text-right align-middle">Cantidad</th>
              <th class="text-right align-middle">P/Unitario</th>
              <th class="text-right align-middle">total</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in waybill.details">
              <td>{{ item.supply_code }}</td>
              <td>{{ item.supply_family }}</td>
              <td>{{ item.supply_name }}</td>
              <td class="text-right align-middle">{{ item.quantity | integer }}</td>
              <td class="text-right align-middle">{{ item.unitary_value }} {{ item.supply_currency }}</td>
              <td class="text-right align-middle">{{ multiplyStringFloat(item.quantity, item.unitary_value) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="font-weight-bold">
              <td class="left"></td>
              <td class="text-right"></td>
              <td class="text-right"></td>
              <td class="text-right">{{ total | integer }}</td>
              <td class="text-right"></td>
              <td class="text-right">
                NETO {{ calculateTotalNet }}<br />
                IVA {{ calculateTax }}<br />
                TOTAL {{ calculateTotal }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!--  <b-row class="mt-3">
          <b-col lg="4" sm="5">
            Notas: {{waybill.note}}
          </b-col>
          <b-col lg="6" sm="6" class="ml-auto">

          </b-col>
        </b-row> -->
    </b-card-body>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";
import locale from "numeral/locales";

numeral.locale("es");

export default {
  name: "Report",
  props: ["waybill"],
  data() {
    return {
      img: ""
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    integer(value) {
      return numeral(value).format("0,0");
    }
  },
  computed: {
    calculateTotalNet() {
      const items = this.waybill.details;
      const value = items.map((item) => item.quantity * parseFloat(item.unitary_value)).reduce((a, b) => a + b, 0);
      return value.toFixed(2);
    },
    calculateTax() {
      return (this.calculateTotalNet * 0.19).toFixed(2);
    },
    calculateTotal() {
      return (this.calculateTotalNet * 1.19).toFixed(2);
    },
    reportType() {
      return this.waybill.waybill_type === 3 ? "ENTRADA " : "SALIDA ";
    },
    total() {
      return this.waybill.details.reduce((acc, item) => acc + item.quantity, 0);
    }
  },
  mounted() {
    this.img = localStorage.getItem("img");
  },
  methods: {
    moment: function () {
      return moment();
    },
    multiplyStringFloat: function (a, b) {
      return (parseFloat(a) * parseFloat(b)).toFixed(2);
    },
    printDiv() {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;
      let stylesHtml = "";
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open("", "", "left=0,top=5,width=1280,height=2900,toolbar=0,scrollbars=0,status=0");
      WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF() {
      const element = document.getElementById("areaImprimir").innerHTML;
      const opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        filename: this.reportType + this.waybill.company.name + " G" + this.waybill.number + ".pdf",
        // html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };
      html2pdf(element, opt);
    }
  }
};
</script>

<style scoped></style>
